/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LearningAreaInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearningAreaApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'LearningAreas');
  }

  find(params?: Record<string, any>): Observable<LearningAreaInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<LearningAreaInterface[]>(path, httpParams);
  }

  public getLearningAreas(params: HttpParams): Observable<{ count: number; results: LearningAreaInterface[] }> {
    return this.get('search', params);
  }

  public createLearningArea(learningArea: LearningAreaInterface): Observable<LearningAreaInterface> {
    return this.post(null, null, learningArea);
  }

  public updateLearningArea(
    params: HttpParams,
    learningArea: LearningAreaInterface
  ): Observable<LearningAreaInterface> {
    return this.put(null, params, learningArea);
  }

  public deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(map(() => true));
  }
}
